import { styled } from "~/generated/styled-system/jsx"
import { button as buttonRecipe } from "~/generated/styled-system/recipes"

export const Button = styled("button", buttonRecipe)
export const AnchorButton = styled("a", buttonRecipe)
